module.exports = __webpack_public_path__ + "img/nav-right-expand-search2.daaa85dc.png";